import { useRouter } from "vue-router";
import { useRoutePermission as pgUseRoutePermission } from "@polargold/pg-frontend-vue";
import { ROUTE } from "@/router/routeDefinitions.ts";
import { useAuthUserStore } from "@/stores/AppStartUp/AuthUserStore";

export const useRoutePermission = () => {
    const router = useRouter();
    const authUserStore = useAuthUserStore();

    return pgUseRoutePermission({
        getUserRoles: () => authUserStore.roles || [],
        isAdmin: () => authUserStore.isAdminUser || false,
        isAuthUserLoaded: () => authUserStore.authUserIsLoaded,
        notAllowedRouteName: ROUTE.PUBLIC_PAGE_NOT_ALLOWED.NAME,
        onNavigationError: async (error, to) => {
            console.group("Routing Error");
            console.error("Error while navigating to", to);
            console.error(error);
            console.groupEnd();
            await router.push({ name: ROUTE.PUBLIC_PAGE_NOT_FOUND.NAME });
        },
    });
};
